import * as React from 'react'
import { withAllContexts } from '../../../AllContextsWrapper';
import { CircularProgress } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { Save, Printer, Package } from 'lucide-react';

class Equipment extends React.PureComponent {
  constructor(props) {
    super(props);
    let { color, client, fees, payments, ...form } = this.props.reservation;
    this.state = {
      isLoading: false,
      form: {
        ...form
      }
    };
  }

  updateFormState = (value, name) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }))
  }

  handleFormSubmit = async (event) => {
    if (event) event.preventDefault();
    this.setState({ isLoading: true });

    this.props.socketIO.socket.emit('reservations:update', this.state.form, (response) => {
      this.setState({ isLoading: false });
      if (response.success === true) {
        this.props.app.functions.updateMainCalendar();
        this.props.app.functions.updateCurrReservation(this.state.form.id);
        enqueueSnackbar("Výbava úspešne aktualizovaná", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Výbavu sa nepodarilo aktualizovať", {
          variant: "error",
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.reservation !== prevProps.reservation) {
      let { color, client, fees, payments, ...form } = this.props.reservation;
      this.setState(({
        form: {
          ...form
        }
      }))
    }
  }

  render() {
    const { activeCalendar } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    
    const primaryBgClass = isCamping ? "bg-taborisko-pine hover:bg-taborisko-pine/90" : "bg-splavma-teal hover:bg-splavma-teal/90";
    const primaryTextClass = isCamping ? "text-taborisko-pine" : "text-splavma-teal";
    const primaryBorderClass = isCamping ? "border-taborisko-pine" : "border-splavma-teal";

    const inputClass = "w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all outline-none text-sm font-medium";
    const labelClass = "block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1.5 ml-1";

    return (
      <div className="space-y-6">
        <div className="flex items-center gap-3 mb-2">
          <div className={`p-2 rounded-lg ${isCamping ? 'bg-taborisko-orange/10 text-taborisko-orange' : 'bg-splavma-orange/10 text-splavma-orange'}`}>
            <Package className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 uppercase tracking-wide">Správa výbavy</h2>
        </div>

        <form onSubmit={this.handleFormSubmit} className="space-y-6">
          <div className="bg-white shadow-sm border border-gray-100 p-5 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className={labelClass}>Kanoe</label>
                <input
                  type="number"
                  name="kanoe_count"
                  className={inputClass}
                  value={this.state.form.kanoe_count || 0}
                  onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                />
              </div>
              <div>
                <label className={labelClass}>Katamarány</label>
                <input
                  type="number"
                  name="katamaran_count"
                  className={inputClass}
                  value={this.state.form.katamaran_count || 0}
                  onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                />
              </div>
              <div>
                <label className={labelClass}>Pádla</label>
                <input
                  type="number"
                  name="paddle_count"
                  className={inputClass}
                  value={this.state.form.paddle_count || 0}
                  onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                />
              </div>
              <div>
                <label className={labelClass}>Vesty</label>
                <input
                  type="number"
                  name="vest_count"
                  className={inputClass}
                  value={this.state.form.vest_count || 0}
                  onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                />
              </div>
              <div>
                <label className={labelClass}>Barely</label>
                <input
                  type="number"
                  name="barrel_count"
                  className={inputClass}
                  value={this.state.form.barrel_count || 0}
                  onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                />
              </div>
            </div>

            <div className="mt-8">
              <label className={labelClass}>Poznámka k výdaju výbavy</label>
              <textarea
                name="equipment_note"
                rows={3}
                className={`${inputClass} resize-none`}
                placeholder="Sem napíšte poznámku k výdaju výbavy..."
                value={this.state.form.equipment_note || ''}
                onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
              />
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pb-8">
            <button
              type="button"
              onClick={() => this.props.app.functions.handlePrint()}
              className={`flex-1 flex items-center justify-center gap-2 py-3.5 px-4 rounded-xl font-bold uppercase tracking-wider text-sm transition-all border-2 bg-white hover:bg-gray-50 ${primaryTextClass} ${primaryBorderClass}`}
            >
              <Printer className="w-5 h-5" />
              Tlačiť výdajku
            </button>
            
            <button
              type="submit"
              disabled={this.state.isLoading}
              className={`flex-1 flex items-center justify-center gap-2 py-3.5 px-4 rounded-xl font-bold uppercase tracking-wider text-sm text-white transition-all shadow-md hover:shadow-lg disabled:opacity-70 ${primaryBgClass}`}
            >
              {this.state.isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <>
                  <Save className="w-5 h-5" />
                  Uložiť zmeny
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default withAllContexts(Equipment);
